// Central brand data for Gormans Contracting

export const BRAND = {
  name: "GORMANS",
  suffix: "CONTRACTING",
  tagline: "BUILDING. ENHANCING. DELIVERING.",
  subline: "ROOFING • LANDSCAPING • GROUNDWORKS & MORE",
  phone: "07984 004171",
  phoneHref: "tel:07984004171",
  email: "zakcornish111@icloud.com",
  website: "www.gormanscontracting.co.uk",
  area: "Leicester, Leicestershire & surrounding areas",
  facebook: "https://www.facebook.com/share/1BHP9V4pvW/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/gormans_contracting111",
};

// Detailed services grouped by category, with indicative pricing
export const SERVICE_CATEGORIES = [
  {
    id: "roofing",
    name: "Roofing",
    blurb: "Repairs, re-roofs, leadwork and everything above the walls.",
    items: [
      { name: "Roof Repairs", price: "From £80" },
      { name: "Emergency Roof Repairs", price: "From £120" },
      { name: "Full Re-Roofs", price: "From £3,500" },
      { name: "Flat Roof Installation (EPDM / Felt)", price: "From £900" },
      { name: "New Roof Installations", price: "Free quotation" },
      { name: "Chimney Repairs & Repointing", price: "From £250" },
      { name: "Ridge Tile Repairs", price: "From £180" },
      { name: "Leadwork Repairs", price: "From £150" },
      { name: "Fascia, Soffit & Guttering Replacement", price: "From £950" },
      { name: "Gutter Repairs & Cleaning", price: "From £60" },
    ],
  },
  {
    id: "landscaping",
    name: "Landscaping",
    blurb: "Driveways, patios, fencing and full garden transformations.",
    items: [
      { name: "Garden Makeovers", price: "Free quotation" },
      { name: "Block Paving Driveways", price: "From £80 / m²" },
      { name: "Cobblecrete Driveways", price: "From £95 / m²" },
      { name: "Slabbing & Patios", price: "From £70 / m²" },
      { name: "Porcelain Patios", price: "From £100 / m²" },
      { name: "Fencing Installation", price: "From £90 / panel" },
      { name: "Turfing", price: "From £18 / m²" },
      { name: "Artificial Grass", price: "From £55 / m²" },
      { name: "Sleeper Borders", price: "From £35 / metre" },
      { name: "Decorative Stone", price: "From £45 / m²" },
    ],
  },
  {
    id: "groundworks",
    name: "Groundworks",
    blurb: "Solid foundations and drainage — the work you build everything on.",
    items: [
      { name: "Foundations", price: "Free quote" },
      { name: "Excavation", price: "Free quote" },
      { name: "Drainage", price: "Free quote" },
      { name: "Concrete Bases", price: "Free quote" },
      { name: "Footings", price: "Free quote" },
      { name: "Site Clearance", price: "Free quote" },
      { name: "Trenching", price: "Free quote" },
    ],
  },
  {
    id: "exterior-cleaning",
    name: "Exterior Cleaning",
    blurb: "Bring roofs, driveways and patios back to life.",
    items: [
      { name: "Roof Cleaning", price: "From £350" },
      { name: "Driveway Pressure Washing", price: "From £150" },
      { name: "Patio Cleaning", price: "From £120" },
      { name: "Gutter Clearing", price: "From £60" },
      { name: "Soft Washing", price: "From £200" },
    ],
  },
];

export const WHY_CHOOSE = [
  "Free, no-obligation quotations",
  "Fully insured",
  "Reliable & professional service",
  "Quality workmanship guaranteed",
  "Domestic & commercial work",
  "Serving Leicester, Leicestershire & surrounding areas",
];

export const MANIFESTO = [
  {
    no: "01",
    word: "BUILDING",
    body: "We lay the groundwork — literally. From foundations to full re-roofs, every project starts with structural integrity and craftsmanship that holds up under scrutiny.",
  },
  {
    no: "02",
    word: "ENHANCING",
    body: "Great construction is only half the story. We enhance every space with considered landscaping, paving and finishing that elevate the everyday.",
  },
  {
    no: "03",
    word: "DELIVERING",
    body: "On time, on budget, no surprises. We deliver work we're proud to put our name on — and clients who come back and recommend us.",
  },
];

export const PROJECTS = [
  {
    label: "Roofing",
    title: "Full Re-Roof Project",
    img: "https://images.unsplash.com/photo-1587582423116-ec07293f0395",
  },
  {
    label: "Landscaping",
    title: "Modern Patio & Garden",
    img: "https://images.unsplash.com/photo-1617850687395-620757feb1f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsYW5kc2NhcGluZyUyMHBhdGlvfGVufDB8fHx8MTc4NTIyNzc2NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "Groundworks",
    title: "Site Excavation",
    img: "https://images.unsplash.com/photo-1759579480718-5b9a35df3178?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxleGNhdmF0b3IlMjBncm91bmR3b3Jrc3xlbnwwfHx8fDE3ODUyMjc3NjR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "Block Paving",
    title: "Driveway Transformation",
    img: "https://images.unsplash.com/photo-1711098256664-d2ea62e6e376?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxibG9jayUyMHBhdmluZyUyMGRyaXZld2F5fGVufDB8fHx8MTc4NTIyNzc2NHww&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1759579480718-5b9a35df3178?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxleGNhdmF0b3IlMjBncm91bmR3b3Jrc3xlbnwwfHx8fDE3ODUyMjc3NjR8MA&ixlib=rb-4.1.0&q=85";

// Flat list of bookable services for the request form
export const SERVICE_OPTIONS = [
  "Roof Repairs",
  "Emergency Roof Repairs",
  "Full Re-Roofs",
  "Flat Roof Installation",
  "New Roof Installation",
  "Chimney Repairs & Repointing",
  "Fascia, Soffit & Guttering",
  "Gutter Repairs & Cleaning",
  "Block Paving Driveway",
  "Cobblecrete Driveway",
  "Slabbing & Patios",
  "Porcelain Patios",
  "Fencing Installation",
  "Turfing / Artificial Grass",
  "Garden Makeover",
  "Groundworks / Foundations",
  "Drainage",
  "Roof Cleaning",
  "Driveway / Patio Cleaning",
  "Soft Washing",
  "Other / Not Sure",
];
